/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePlanRequest } from '../../models/create-plan-request';
import { PlanDto } from '../../models/plan-dto';

export interface BillingPlansPost$Json$Params {
      body?: CreatePlanRequest
}

export function billingPlansPost$Json(http: HttpClient, rootUrl: string, params?: BillingPlansPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
  const rb = new RequestBuilder(rootUrl, billingPlansPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlanDto>;
    })
  );
}

billingPlansPost$Json.PATH = '/billing/plans';
